<div class="authenticated-content-wrapper">
  <router-outlet></router-outlet>
</div>
<app-sabis-chatbot />
